import prettyMilliseconds from 'pretty-ms';

// Our Use-Case
// Only Minutes: 40mins | Only Hour: 2hrs | Hours + Mins: 1h 40m
// Output of pretty-ms
// with { verbose: true }: 15 days 11 hours 1 minute 9 seconds
// with { verbose: false }: 15d 11h 23m 20s
// so we are applying a regex `/\d\s/g` on output of { verbose: true }
// if the matches of this regex pattern is > 1
// we will return the output with { verbose: false }

const REGEX_COUNT_SPACES = /\d\s/g;

const getHumanDuration = (durationInSeconds?: number | null, colonNotation: boolean = false) => {
  const durationInMilliseconds = (durationInSeconds || 0) * 1000;
  const humanDurationVerbose = prettyMilliseconds(durationInMilliseconds, {
    verbose: !colonNotation,
    colonNotation,
  })
    .replace('minute', 'min')
    .replace('second', 'sec');

  // @ts-ignore
  if (humanDurationVerbose.match(REGEX_COUNT_SPACES)?.length > 1) {
    return prettyMilliseconds(durationInMilliseconds);
  }

  return humanDurationVerbose;
};

export const getHumanDurationShorthand = (durationInSeconds?: number | null) => {
  const durationInMilliseconds = (durationInSeconds || 0) * 1000;
  return prettyMilliseconds(durationInMilliseconds);
};

export const getHumanDurationInHours = (durationInSeconds: number = 0) => {
  const inHours = Math.floor(durationInSeconds / 3600);
  const inMinutes = Math.floor((durationInSeconds % 3600) / 60);
  const inSeconds = Math.floor(durationInSeconds % 60);

  return `${inHours ? inHours + 'h' : ''} ${inMinutes ? inMinutes + 'm' : ''} ${
    inSeconds ? inSeconds + 's' : ''
  }`.trim();
};

export const roundToMinutes = (durationInSeconds?: number | null) =>
  Math.round((durationInSeconds || 0) / 60) * 60;

export default getHumanDuration;
